enum ACTIONS {
    FETCH_FILES = '[FILES] - FETCH BY ENTITY ID',
    PATCH_FILE = '[FILES] - PATCH BY ID',
    DELETE_FILE = '[FILES] - DELETE BY ID',
    UPLOADING_FILES = '[FILES] - UPLOADING FOR ENTITY ID'
}

export default ACTIONS;